<div class="feature-section bg-lem-yellow-light p-3 rounded-3">
    <h2 class="fs-4 mb-4 fw-semibold text-center">Üben und trainieren direkt im Buch</h2>
    <div #features id="section-student-information" class="feature-list align-items-start d-flex gap-4 justify-content-center">
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'ubungsreihen.png' | asset" alt="Feature digi.trainer" />
            <span><strong>digi.trainer (zusätzliche Beispiele)</strong><br/>Stärken & Schwächen, Lernziele, Kompetenzen</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-feedback.png' | asset" alt="Feature Feedback" />
            <span><strong>Feedback</strong><br />Wie ist es dir gegangen? Du siehst, wieviel richtig ist.</span>
        </div>
        <div class="feature-item d-flex flex-column gap-2 justify-content-start align-items-center">
            <img [src]="'welcome/icon-help-solution.png' | asset" alt="Feature Hinweise und Lösungswege" />
            <span><strong>Hinweise und Lösungswege</strong></span>
        </div>
    </div>
</div>